import React from 'react';
import { Button, Result } from 'antd';
import { ToolOutlined } from '@ant-design/icons';
import { SUPPORT_HOTLINE_DISPLAY, SUPPORT_ZALO_URL } from '../../../constants/supportBotData.js';

// Hiện khi PAYMENT_ENABLED = false: báo thanh toán trực tuyến đang triển khai, mời khách nhắn Zalo đăng ký gói
export function PaymentComingSoon({ planName, extra }) {
  return (
    <Result
      icon={<ToolOutlined style={{ color: '#005537' }} />}
      title="Thanh toán trực tuyến đang được triển khai"
      subTitle={
        <>
          Tính năng thanh toán{planName ? ` gói ${planName}` : ''} sẽ sớm mở. Trong thời gian này, anh/chị vui lòng
          nhắn Zalo <b>{SUPPORT_HOTLINE_DISPLAY}</b> để được tư vấn và đăng ký gói học.
        </>
      }
      extra={[
        <Button
          key="zalo"
          type="primary"
          href={SUPPORT_ZALO_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ background: '#0068ff', borderColor: '#0068ff' }}
        >
          Nhắn Zalo tư vấn
        </Button>,
        ...(extra ? [extra] : []),
      ]}
    />
  );
}
